module.exports = __webpack_public_path__ + "static/media/producing_asset_0.cd8cc76e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/producing_asset_0.jpg
// module id = 1852
// module chunks = 0